import { Component, Vue, Watch } from 'vue-property-decorator';

import template from './add-user.vue';
import { Action } from '@/store';
import { ModalState } from '@/definitions';
import apiService from '@/services/api.service';

@Component({
  mixins: [template],
})
export default class AddUser extends Vue {
  email: string = '';
  firstname: string = '';
  lastname: string = '';
  showErrors: boolean = false;
  emailError: string = '';

  @Watch('$store.state.modal.active')
  resetComponent(active: boolean) {
    if (active) {
      this.email = '';
      this.firstname = '';
      this.lastname = '';
      this.showErrors = false;
    }
  }

  @Watch('email')
  checkEmail(email: string) {
    if (this.emailError === 'email_invalid' && /.+@.+\.[a-zA-Z]+/.test(email)) {
      this.emailError = '';
    }
  }

  get modal(): ModalState {
    return this.$Store.state.modal;
  }

  async saveUser() {
    if (this.email && this.firstname && this.lastname) {
      if (!/.+@.+\.[a-zA-Z]+/.test(this.email)) {
        this.emailError = 'email_invalid';
      } else {
        try {
          await apiService.createUser({ email: this.email, firstName: this.firstname, lastName: this.lastname });
          this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.users.save_success', type: 'success' });
          this.closeModal();
        } catch (e) {
          this.emailError = 'email_exists';
        }
      }
    } else {
      this.showErrors = true;
    }
  }

  closeModal(): void {
    this.$Store.dispatch(Action.HIDE_MODAL);
  }
}